import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiUrl } from '../utils/api';
import { marked } from 'marked'; // <-- Add this import

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await fetch(apiUrl(`/api/blog/${id}`)); // Replace with your API endpoint
        if (!res.ok) throw new Error('Failed to fetch blog');
        const data = await res.json();

        // Ensure the blog has a valid imageUrl
        setBlog({
          ...data,
          imageUrl: data.imageUrl && data.imageUrl.startsWith('http')
            ? data.imageUrl
            : 'https://via.placeholder.com/800x400', // Default image if missing or invalid
        });
      } catch (err) {
        console.error('Failed to fetch blog:', err);

        // Fallback to a static blog
        setBlog({
          id,
          title: 'Fallback Blog Title',
          createdAt: '2023-01-01',
          imageUrl: 'https://via.placeholder.com/800x400', // Default fallback image
          content:
            'This is a fallback blog content. The actual blog could not be loaded due to a server issue. Please try again later.',
        });
      }
    };

    fetchBlog();
  }, [id]);

  if (!blog) return <div className="text-center py-12">Loading...</div>;

  return (
    <div className="max-w-3xl mx-auto py-12 px-4 font-sans">
      <h1 className="text-4xl font-bold text-blue-800 mb-4">{blog.title}</h1>
      <p className="text-sm text-gray-500 mb-6">
        {new Date(blog.createdAt).toDateString()}
      </p>
      {blog.imageUrl && (
        <img
          src={blog.imageUrl}
          alt={blog.title}
          className="w-full h-auto rounded-lg mb-6 shadow-md"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://via.placeholder.com/800x400';
          }}
        />
      )}
      {/* Convert Markdown to HTML */}
      <div
        className="text-lg text-gray-700"
        dangerouslySetInnerHTML={{ __html: marked.parse(blog.content || '') }}
      />
    </div>
  );
};

export default BlogDetails;
